import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbVbComponent } from './breadcrumb-vb.component';



@NgModule({
  declarations: [BreadcrumbVbComponent],
  imports: [
    CommonModule
  ],
  exports: [
    BreadcrumbVbComponent
  ]
})
export class BreadcrumbVbModule { }
